/**
 * The section rules that break a document into its fixed order.
 *
 * Shared by both reader views so a reviewer toggling between them keeps the same
 * sense of where they are in the page.
 */
export function SectionRule({ label }: { label: string }) {
  return (
    <div className="gr-rule">
      <span>{label}</span>
      <i />
    </div>
  );
}
